import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import { Circle, ArrowForward } from '@mui/icons-material';
import { FadeInSection } from '../Animations/FadeInAnimation';

const processSteps = [
  {
    label: 'Discovery & Planning',
    description: 'We analyze your requirements and create a detailed project roadmap.'
  },
  {
    label: 'Design & Architecture',
    description: 'Our team designs the solution architecture and user experience.'
  },
  {
    label: 'Development',
    description: 'Agile development with regular updates and feedback integration.'
  },
  {
    label: 'Testing & QA',
    description: 'Comprehensive testing to ensure quality and performance.'
  },
  {
    label: 'Deployment',
    description: 'Smooth deployment and production environment setup.'
  },
  {
    label: 'Maintenance & Support',
    description: '24/7 support and continuous improvement of your solution.'
  }
];

export const ProcessSection: React.FC = () => (
  <FadeInSection delay={0.4}>
    <Box sx={{ py: 8, bgcolor: 'background.paper' }}>
        <Container maxWidth="lg">
          <Typography variant="h3" align="center" gutterBottom>
            Our Development Process
          </Typography>
          <Typography
            variant="subtitle1"
            align="center"
            color="text.secondary"
            paragraph
            sx={{ mb: 6 }}
          >
            A systematic approach to delivering high-quality software solutions
          </Typography>
          <FadeInSection delay={0.4}>
            <Box sx={{ overflowX: 'auto', py: 4 }}>
              <Grid 
                container 
                spacing={2} 
                sx={{ 
                  minWidth: { xs: '800px', lg: '100%' },
                  width: '100%'
                }}
              >
                {processSteps.map((step, index) => (
                  <Grid item xs key={index} sx={{ position: 'relative' }}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 2,
                        height: '100%',
                        border: '1px solid',
                        borderColor: 'divider',
                        borderRadius: 2,
                        transition: 'transform 0.2s',
                        '&:hover': {
                          transform: 'translateY(-4px)',
                          boxShadow: 2
                        }
                      }}
                    >
                      <Box 
                        sx={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          mb: 1,
                          color: 'primary.main' 
                        }}
                      >
                        <Circle sx={{ mr: 1, fontSize: 12 }} />
                        <Typography variant="h6" gutterBottom sx={{ color: 'text.primary' }}>
                          {step.label}
                        </Typography>
                      </Box>
                      <Typography variant="body2" color="text.secondary">
                        {step.description}
                      </Typography>
                    </Paper>
                    {index < processSteps.length - 1 && (
                      <Box
                        sx={{
                          position: 'absolute',
                          right: -10,
                          top: '50%',
                          transform: 'translateY(-50%)',
                          zIndex: 1,
                          color: 'primary.main'
                        }}
                      >
                        <ArrowForward />
                      </Box>
                    )}
                  </Grid>
                ))}
              </Grid>
            </Box>
          </FadeInSection>
          
        </Container>
     </Box>

  </FadeInSection>
  
);

export default ProcessSection;